import { createAuthClient } from 'better-auth/react';

/**
 * Cliente de autenticação. Só entrar, sair e trocar senha — o que a pessoa
 * pode fazer depois de entrar vem do backend, em `/api/platform/context`.
 */
export const auth = createAuthClient({
  baseURL: `${window.location.origin}/api/auth`,
});
